// This import loads the firebase namespace along with all its type information.
import SeasonSnapshot from './season-snapshot-model'

export async function load_seasonSnapshots(): Promise<SeasonSnapshot[]> {
  throw 'Not implemented'
}

export async function delete_seasonSnapshot(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_seasonSnapshot(): Promise<SeasonSnapshot> {
  throw 'Not implemented'
}
